import { Card } from "semantic-ui-react";
import { NewPageComponent } from "../components/page/NewPageComponent";
import {
  CREATE_LIFE_DOMAIN,
  DELETE_LIFE_DOMAIN,
  LIST_LIFE_DOMAINS,
  UPDATE_LIFE_DOMAIN,
} from "./routes";
import { getEventMetadata, getSession } from "../helper";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";
import { CardDotMenuComponent } from "../components/new_card/dot_menu/CardDotMenuComponent";
import { getLifeDomainForm } from "./life_domain_form";

const LifeDomainCard = (props: {
  data: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <Card fluid key={props.data.id}>
      <Card.Content>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="card-header"
        >
          <Card.Header style={{ fontSize: 18 }}>
            <b>{props.data.name}</b>
          </Card.Header>
          <CardDotMenuComponent
            setReloadKey={props.setReloadKey}
            pageData={props.pageData}
            setPageData={props.setPageData}
            cardData={props.data}
            props={{
              menuItems: [
                {
                  type: "api_call",
                  label: "Delete",
                  apiCall: DELETE_LIFE_DOMAIN,
                  callback: (
                    data: any,
                    setReloadKey: any,
                    pageData: any,
                    setPageData: any,
                  ) => {
                    setReloadKey((prev: number) => prev + 1);
                  },
                  apiCallVariables: (data: any) => {
                    return {
                      id: props.data.id,
                      session: getSession(),
                      eventMetadata: getEventMetadata(),
                      isChildElement: true,
                    };
                  },
                  showMenuOption: (data: any) => {
                    return data.hasChildren === false;
                  },
                },
                {
                  type: "new_form_modal",
                  label: "Delete",
                  apiCall: DELETE_LIFE_DOMAIN,
                  modalHeader: "Choose Delete Strategy for " + props.data.name,
                  showMenuOption: (data: any) => {
                    return data.hasChildren && data.parentLifeDomain;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: [
                        {
                          type: "radio_button",
                          key: "parentDeletionStrategy",
                          label:
                            "When deleting this life domain, what should be done with its children (both elements and other life domains)?",
                          options: [
                            {
                              value: "delete_all",
                              label: "Delete all",
                            },
                            {
                              value: "orphan_children",
                              label: "Keep all",
                            },
                            {
                              value: "promote_children",
                              label:
                                "Promote children to be under Life Domain's parent Life Domain",
                            },
                          ],
                        },
                      ],
                      type: "single_form",
                    },
                    startingData: {
                      id: props.data.id,
                      isChildElement: false,
                      parentDeletionStrategy: "delete_all",
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  label: "Delete",
                  apiCall: DELETE_LIFE_DOMAIN,
                  modalHeader: "Choose Delete Strategy for " + props.data.name,
                  showMenuOption: (data: any) => {
                    return data.hasChildren && !data.parentLifeDomain;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: [
                        {
                          type: "radio_button",
                          key: "parentDeletionStrategy",
                          label:
                            "When deleting this life domain, what should be done with its children (both elements and other life domains)?",
                          options: [
                            {
                              value: "delete_all",
                              label: "Delete all",
                            },
                            {
                              value: "orphan_children",
                              label: "Keep all",
                            },
                          ],
                        },
                      ],
                      type: "single_form",
                    },
                    startingData: {
                      id: props.data.id,
                      isChildElement: false,
                      parentDeletionStrategy: "delete_all",
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },

                {
                  type: "new_form_modal",
                  label: "Edit",
                  modalHeader: "Edit Life Domain",
                  apiCall: UPDATE_LIFE_DOMAIN,
                  showMenuOption: (data: any) => {
                    return true;
                  },
                  callback: (data: any) => {
                    props.setReloadKey((prev: number) => prev + 1);
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: getLifeDomainForm(),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                      id: props.data.id,
                      parentLifeDomainId:
                        props.data.parentLifeDomain?.id || undefined,
                    },
                  }),
                },
              ],
            }}
          />
        </div>
      </Card.Content>
      <Card.Content className="children-elements">
        {props.data.children &&
          props.data.children.map((child: any) => {
            return (
              <LifeDomainCard
                key={child.id}
                data={child}
                setReloadKey={props.setReloadKey}
                pageData={props.pageData}
                setPageData={props.setPageData}
              />
            );
          })}
      </Card.Content>
    </Card>
  );
};

export const NewLifeDomainPage = () => {
  return (
    <NewPageComponent
      props={{
        type: "parent_child_list",
        card: LifeDomainCard,
        parentItem: "parentLifeDomain",
        query: {
          documentNode: LIST_LIFE_DOMAINS,
          key: "listLifeDomains",
        },
        queryVariables: {
          session: getSession(),
        },
        itemName: "Life Domain",
        creationProps: {
          formComponentProps: new NewNewFormComponentProps({
            form: {
              formFields: getLifeDomainForm(),
              type: "single_form",
            },
            startingData: {
              name: "",
              parentLifeDomainId: undefined,
            },
          }),
          apiCall: {
            documentNode: CREATE_LIFE_DOMAIN,
            key: "createLifeDomain",
          },
        },
      }}
    />
  );
};
